module.exports = __webpack_public_path__ + "img/aus.dcca80ae.svg";